import MessageChat from './MessageChat';

export default MessageChat;